<div class="w-full">
  <!-- Top border - 40px on desktop, 20px on mobile -->
  <div class="h-5 md:h-10 bg-marty-green"></div>
  
  <!-- Main header content -->
  <div class="bg-white px-4 py-2.5 md:py-8">
    <div class="w-[840px] max-w-[100%] mx-auto flex items-center justify-between">
      <!-- Logo - left aligned with responsive scaling -->
      <div class="flex items-center w-1/2 justify-start">
        <img 
          class="object-contain w-[300px] max-w-[100%]" 
          src="https://cdn.drmartypets.com/images/drMarty_logo-registered22.png" 
          alt="DR. MARTY"
        >
      </div>
      
      <!-- Phone section - right aligned -->
      <div class="flex items-center gap-2 px-3 py-2 rounded w-1/2 justify-end">
        <img 
          class="h-[30px] md:h-auto w-auto" 
          src="https://cdn.drmartypets.com/images/phone.png" 
          alt="Phone"
        >
        <span class="font-medium text-marty-slateblue oswald" [innerHTML]="dynamicPhoneNumber"></span>
      </div>
    </div>
  </div>
  
  <!-- Bottom border - 4px -->
  <div class="h-1 bg-marty-slateblue"></div>
</div>